import { AppMessage } from '@/common/components';
import { useAppSocket } from '@/common/hooks';

import { Site, SiteArchiveUploadStatus, SiteArchivesGatewayKeys, SiteArchivesKeys } from '@/modules/Sites';

import { Tag, } from 'antd';
import { QueryClient } from 'react-query';

interface Data {
  siteId: string;
  archiveId: string;
  status: SiteArchiveUploadStatus;
}

interface Args {
  siteId: string;
  isSiteRequestSuccess: boolean;
  queryClient: QueryClient;
}

export const useUpdateArchiveUploadStatus = ({ queryClient, isSiteRequestSuccess, siteId }: Args) => {
  const appMessageApi = AppMessage.useControls();

  useAppSocket<Data>(SiteArchivesGatewayKeys.UpdateUploadStatus, async ({ lastMessage }) => {
    if (siteId && isSiteRequestSuccess) {
      const { archiveId, siteId: archiveSiteId, status } = lastMessage;

      if (siteId === archiveSiteId) {
        await queryClient.refetchQueries([SiteArchivesKeys.GetArchives, siteId], { exact: true });

        if (status === SiteArchiveUploadStatus.Success || status === SiteArchiveUploadStatus.Error) {
          const archivesData = queryClient.getQueryData<Site['archives']>([SiteArchivesKeys.GetArchives, siteId]);

          archivesData?.forEach(arch => {
            if (arch.id === archiveId) {
              if (status === SiteArchiveUploadStatus.Success) {
                appMessageApi.success(<>Архів <Tag>{ arch.file.name }</Tag> успішно опрацьовано!</>, {
                  key: arch.id
                });
              }

              if (status === SiteArchiveUploadStatus.Error) {
                appMessageApi.error(<>Архів <Tag>{ arch.file.name }</Tag> не вдалось опрацювати</>, {
                  key: arch.id
                });
              }
            }
          });
        }
      }
    }
  });
};
